import React from "react";
import { Box, Flex, Text, Image, Heading, Spacer } from "@chakra-ui/react";
import { TimeLine } from "../../Components";
const testData = [
  {
    institution:
      "Jomo Kenyatta University of Agriculture and Technology(JKUAT)",
    year: "2019 - 2021",
    certification: "Diploma In Information Technology(IT)",
    description:
      "Completed  and obtained my Diploma Certificate in Information Technology.",
    logoUrl: "asset/jkuat.jpeg",
  },
  {
    institution: "St Claire Of Assisi Girls High School",
    year: "2013 - 2017",
    certification: "Kenya Certificate of Secondary Education",
    description:
      "Completed  and obtained my Kenya Certificate of Secondary Education.",
    logoUrl: "asset/scl.jpeg",
  },
];

const About = () => {
  return (
    <Box p={4} id="about" mt="100px">
      <Flex
        alignItems="center"
        gap="10px"
        flexDirection={{ base: "column", md: "column", lg: "row" }}
        mb={8}
      >
        <Box>
          <Heading mb={4} textAlign={{ base: "center", md: "left" }}>
            Glad to meet you
          </Heading>
          <Text fontSize="1.2rem" mb={4}>
            As a Figma enthusiast, I appreciate the platform's versatility and
            collaborative features, which have allowed me to streamline design
            workflows and deliver exceptional results efficiently.
          </Text>
          <Text fontSize="1.2rem" mb={4}>
            Whether it's designing for mobile apps, websites, or other digital
            platforms, I relish the challenge of creating solutions that not
            only meet but exceed user expectations I love working with
            decision-makers at the intersection of design, strategy, and
            business.
          </Text>
          <Text fontSize="1.2rem">
            I believe this is where design can have the most significant impact.
            In 2022, I started my independent design practice, using my
            experience to help early-stage startups create high-quality products
            that customers love and help businesses thrive.
          </Text>
        </Box>
        <Spacer />
        <Image
          src="sharon.png"
          alt="Sharon Nyambura"
          boxSize={{ base: "300px", md: "450px", lg: "450px" }}
        />
      </Flex>
      <Box mt="100px">
        <Heading mb={8} textAlign={{ base: "center", md: "left" }}>
          Education
        </Heading>
        <Box>
          <TimeLine items={testData} />
        </Box>
      </Box>
    </Box>
  );
};

export default About;
